// extracted by mini-css-extract-plugin
export var connectionButton = "_bz-1";
export var connectionButtonFloating = "_bz-2";
export var connectionContainer = "_bz-0";
export var rightPanel = "_bz-6";
export var stepCard = "_bz-3";
export var stepCardSubtitle = "_bz-5";
export var stepCardText = "_bz-4";